<template>
  <page>
    <template slot="content">
      <help-content :title="'歩数が0のまま同期できない(iPhone)'">
        <template slot="content">
          <div class="title">アクセス権限を許可</div>
          <div class="text p">
            WeRUNを初めて使う時に、<b>モーションとフィットネス</b>と<b>モバイルデータ通信</b>へのアクセスを許可するダイアログが表示されるので、<b>すべて許可</b>してください。<br><br>
            「許可しない」を選択してしまった場合、スマホの「設定＞プライバシー＞モージョンとフィットネス」及び、「設定＞WeRUN＞モバイルデータ通信」にて許可してください。
          </div>
          <img class="picture" src="../assets/images/q_and_a/H9_2.png">
          <div class="title">アプリを定期的に開く</div>
          <div class="text p">データの紛失を防ぐため、毎晩(または運動後に)アプリを開き、ホームを下スワイプしてデータの同期を行うことをおすすめします。<br><br>
          WeRUNでは<b>過去７日間</b>のデータしか同期できないようになっています。７日間を超えてアプリを開いた場合はデータが紛失することがありますので、ご注意ください。</div>
          <img class="picture" src="../assets/images/q_and_a/8.png">
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help2.vue